import React, { useState, useEffect } from 'react';
import { apiGetCall, apiDeleteCall, isResultOk } from './../../components/special/apiCall';
import { useLocale } from './../../components/special/LanguageProvider';
import { Link, useLocation } from 'react-router-dom';
import ListHeader from './../../components/form/ListHeader';
import ListTable from './../../components/form/ListTable';
import RowChangeButton from './../../components/button/RowChangeButton';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import RowButtons from './../../components/button/RowButtons';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ClaimTypeList = ()  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  const setIsPageLoading = usePageLoadingContext();
  const setCheckErrorItems = useErrorContext();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/claimtype/summary');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);  

  const onDeleteTableClick = async(claimtype) => {
    setIsPageLoading(true);
    let requestResult = await apiDeleteCall(BASE_URL + '/admin/claimtype/remove/' + claimtype.claimTypeID);
    // let requestResult = await apiPostCall(BASE_URL + '/admin/table/remove', {TableTypeID: table.tableTypeID, TableID: table.tableID});
    if (isResultOk(requestResult, setCheckErrorItems)){
      await loadList();
    }
    setIsPageLoading(false);
  }
  
    return (    
      <div>      
        <ListHeader title={t("Kröfu Tegundir")}/>
        <div className="text-right"><Link to={"/admin/claimtypes/edit?new=true"} className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna nýja tegund")}</Link></div>
        <ListTable
            error = {listError}
            isLoading = {listLoading}
            list = {list}
            colsettings = {['180px', '', '120px', '', '']}
            headers = {[
              t("Tegund"),
              t("Nafn"),
              t("Leyfa veð"),
              t("Fjöldi krafa"),
              ''
            ]}
            columns = {[
              (item => (<span>{item.claimTypeMethodName}</span>)),
              (item => (<span>{item.claimTypeName}</span>)),
              (item => (<span>{item.allowCollateral ? "Já" : "Nei"}</span>)),
              (item => (<span>{item.numberOfClaims}</span>)),
              (item => (<RowButtons>
                {item.numberOfClaims === 0 && <RowDeleteButton onClick={() => onDeleteTableClick(item)}/>}
                <RowChangeButton link={"/admin/claimtypes/edit?claimtypeid="+item.claimTypeID}/>                    
              </RowButtons>))
            ]}
  
        />
    </div>
    );
};
